import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  HostBinding,
} from '@angular/core';
import {supportedFileTypes} from '@home365/data/entities';
export interface MediaCell {
  src: string;
  type: string;
  thumbnail?: string;
  loading?: boolean;
  isPrimary?: boolean
}

@Component({
  selector: 'lib-carousel-media-cell',
  templateUrl: './carousel-media-cell.component.html',
  styleUrls: ['./carousel-media-cell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselMediaCellComponent {
  @Output()
  action: EventEmitter<any> = new EventEmitter<any>();
  @Input() objectFit: "contain" | "cover" | "none" | "fill" = 'cover';
  @Input() allowDelete = false;
  @Input() allowPrimaryTypes = [];
  @Input() isOwner: boolean = false;
  isLoading: boolean | undefined;
  @Input()
  get media(): MediaCell { return this._media }
  set media(val: any) {
    this._media = {...val, ...this._media};
    if (val.src) {
      this.setMediaType(val);
    } else if (val.image) {
      this._media.src = val.image.path;
      this._media.type = val.image.type;
      this._media.isPrimary = val.image.isPrimary;
    }
  }
  private _media: MediaCell = {src: '', type: ''};

  //Sprint 77 - Photos Gallery Manager
  borderRadius!: number;
  @Input() isGalleryManager!: boolean;
  @HostBinding('class.photos-manager') get galleryManager() {
    if (this.isGalleryManager) {
      this.borderRadius = 10;
    }
    return this.isGalleryManager;
  }

  constructor() { }

  private setMediaType(media: MediaCell) {
    media.src = media.src?.replace("http://", "https://")
    const splitImgUrl: string[] = media.src.split(".");
    const fileType = splitImgUrl.pop();
    if (fileType) {
      if (supportedFileTypes.supportedVideos.includes(fileType)) {
        media['type'] = 'video'
      } else if (supportedFileTypes.supportedImages.includes(fileType)) {
        media['type'] = 'image'
      } else if (fileType == 'pdf') {
        media['type'] = 'pdf'
      } else if (supportedFileTypes.supportedText.includes(fileType)) {
        media['type'] ='text'
      }
    }
  }

  delete(media: MediaCell) {
    this.action.emit({action: 'remove', value: media})
  }

  setLoading(event: boolean) {
    this.isLoading = event;
  }

  favouritesClicked(e: string) {
    if(!this.isOwner) {
      switch (e) {
        case 'set-primary':
          // this._media.isPrimary = true;
          this.action.emit({action: 'set-primary', value: this._media})
          break;
        case 'remove-primary':
          // this._media.isPrimary = false;
          break;
      }
    }
  }

  get canShowFavourite() {
    // @ts-ignore
    return this.allowPrimaryTypes.includes(this.media.type)
  }

}
